module.exports = __webpack_public_path__ + "static/img/bg-topup-slider.5ccdc71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-topup-slider.jpg
// module id = g7Zk
// module chunks = 1